import { render, staticRenderFns } from "./VueSelect.vue?vue&type=template&id=3c9b405c&scoped=true&"
import script from "./VueSelect.vue?vue&type=script&lang=js&"
export * from "./VueSelect.vue?vue&type=script&lang=js&"
import style0 from "./VueSelect.vue?vue&type=style&index=0&id=3c9b405c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b405c",
  null
  
)

component.options.__file = "VueSelect.vue"
export default component.exports